import { Logo } from "../Logo";
import { Button } from "../ui/button";

export const Nav = ({ onRequestDemo }) => {
  return (
    <nav
      className="fixed top-0 left-0 w-full z-50 backdrop-blur-xl border-b border-[#1e1e1e] bg-[#0a0a0a]/85"
      data-testid="nav"
    >
      <div className="max-w-[1220px] mx-auto px-10 py-4 flex items-center justify-between">
        <a href="/" className="flex items-center gap-3 cursor-pointer" data-testid="nav-logo">
          <Logo />
          <span className="text-[1.05rem] font-medium tracking-[-0.3px] text-white">
            Veranda
          </span>
        </a>
        <Button
          onClick={onRequestDemo}
          className="bg-[#3b82f6] hover:bg-[#2563eb] text-white font-semibold text-[0.85rem] rounded-[8px] px-5 py-2 transition-all duration-200 hover:-translate-y-[1px] shadow-glow hover:shadow-glow-hover"
          data-testid="nav-demo-btn"
        >
          Request a Demo
        </Button>
      </div>
    </nav>
  );
};
